import { Component } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { B2BPaymentTypeEnum, CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root'
import {
  CheckoutPaymentMethodComponent,
  CheckoutStepService
} from '@spartacus/checkout/base/components'
import { CheckoutDeliveryAddressFacade, CheckoutPaymentFacade } from '@spartacus/checkout/base/root'
import { GlobalMessageService, TranslationService, UserPaymentService } from '@spartacus/core'
import { Subscription } from 'rxjs'
import { debounceTime, take } from 'rxjs/operators'

@Component({
    selector: 'eb-payment-method',
    templateUrl: './eb-payment-method.component.html',
    styleUrls: ['./eb-payment-method.component.scss'],
    standalone: false
})
export class EbPaymentMethodComponent extends CheckoutPaymentMethodComponent {
  orderReference: string
  activeCart$ = this.activeCartFacade.getActive()
  paymentMethodsForm: UntypedFormGroup
  protected readonly subscriptions = new Subscription()
  constructor(
    userPaymentService: UserPaymentService,
    checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    checkoutPaymentFacade: CheckoutPaymentFacade,
    activatedRoute: ActivatedRoute,
    translationService: TranslationService,
    activeCartFacade: ActiveCartFacade,
    checkoutStepService: CheckoutStepService,
    globalMessageService: GlobalMessageService,
    protected checkoutPaymentTypeService: CheckoutPaymentTypeFacade
  ) {
    super(
      userPaymentService,
      checkoutDeliveryAddressFacade,
      checkoutPaymentFacade,
      activatedRoute,
      translationService,
      activeCartFacade,
      checkoutStepService,
      globalMessageService
    )
  }

  ngOnInit() {
    super.ngOnInit()
    this.subscriptions.add(
      this.activeCart$.pipe(take(1)).subscribe(cart => {
        this.paymentMethodsForm = new UntypedFormGroup({
          poNumber: new UntypedFormControl(cart?.purchaseOrderNumber, {
            updateOn: 'change'
          })
        })
        this.initFormControls()
      })
    )
  }

  initFormControls() {
    this.subscriptions.add(
      this.paymentMethodsForm.controls.poNumber.valueChanges
        .pipe(debounceTime(500))
        .subscribe(value =>
          this.checkoutPaymentTypeService.setPaymentType(B2BPaymentTypeEnum.INVOICE, value)
        )
    )
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }
}
